import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import ErrorBoundary from "@/components/ErrorBoundary";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import CreateCellsPage from "@/pages/CreateCellsPage";
import LibraryPage from "@/pages/LibraryPage";
import PacksPage from "@/pages/PacksPage";
import GenerateBlocPage from "@/pages/GenerateBlocPage";
import LiveMeasurementPage from "@/pages/LiveMeasurementPage";
import CellHistoryPage from "@/pages/CellHistoryPage";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-background cyber-grid-bg" data-testid="loading-screen">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-2 border-neon-blue border-t-transparent rounded-full animate-spin" />
          <span className="text-muted-foreground font-mono text-sm neon-text-blue">Chargement...</span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/register" element={<RegisterPage />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<ErrorBoundary><DashboardPage /></ErrorBoundary>} />
              <Route path="/cells/create" element={<ErrorBoundary><CreateCellsPage /></ErrorBoundary>} />
              <Route path="/library" element={<ErrorBoundary><LibraryPage /></ErrorBoundary>} />
              <Route path="/packs" element={<ErrorBoundary><PacksPage /></ErrorBoundary>} />
              <Route path="/generate-bloc" element={<ErrorBoundary><GenerateBlocPage /></ErrorBoundary>} />
              <Route path="/live" element={<ErrorBoundary><LiveMeasurementPage /></ErrorBoundary>} />
              <Route path="/cells/:cellId/history" element={<ErrorBoundary><CellHistoryPage /></ErrorBoundary>} />
            </Route>
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
